import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { map, catchError } from 'rxjs/operators';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { ConsultaVlansDto } from '../shared/models/consulta-vlans-dto';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { SesionService } from '../shared/services/sesion.service';
import { environment } from '../../environments/environment';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
@Component({
  selector: 'app-consultar-vlan',
  templateUrl: './consultar-vlan.component.html',
  styleUrls: ['./consultar-vlan.component.css']
})
export class ConsultarVlanComponent implements OnInit {

  public codigoAmbienteSedes = environment.listaItemAmbienteSedes;
  private codigoListaAmbientes = environment.listaCodigoAmbientes;

  companias: Compania[];
  companiasFiltradas: Compania[];
  ciudades: Ciudad[];
  ciudadesFiltradas: Ciudad[];
  sedes: Sede[];
  sedesFiltradas: Sede[];
  ambientes: ListaItem[];
  vlans: ConsultaVlansDto[] = new Array<ConsultaVlansDto>();
  idCompaniaSeleccionada = -1;
  companiaSeleccionada: Compania = new Compania();
  idCiudadSeleccionada = -1;
  idSedeSeleccionada = -1;
  idAmbienteSelecccionado = -1;
  idVlanSeleccionado = -1;
  indexSeleccionado: number;
  idCompaniaNueva = -1;
  idCiudadNueva = -1;
  ciudadesEditar: Ciudad[] = new Array<Ciudad>();
  idSedeNueva = -1;
  sedesEditar: Sede[] = new Array<Sede>();
  estadoNuevo: boolean;
  nombreNuevo = '';
  modalRef: NgbModalRef;
  puedeInactivarVLAN = false;
  @ViewChild('downloadLink') private downloadLink: ElementRef;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private administradorIpService: AdministradorIpService,
    private sesionService: SesionService, private modalService: NgbModal) { }

  ngOnInit() {
    this.listarCompanias();
    this.listarCiudadades();
    this.listarSedes();
    this.listarAmbientes();
    this.sesionService.permisoInactivarVLAN().subscribe(
      respuesta => {
        this.puedeInactivarVLAN = respuesta;
      }
    );
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public listarCiudadades(): void {
    this.ciudadService.listarCiudades().subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public listarCiudadaesPorCompania(): void {
    this.idCiudadNueva = -1;
    this.idSedeNueva = -1;
    this.ciudadesEditar = null;
    this.sedesEditar = null;
    this.ciudadService.ciudadesPorIdCompania(this.idCompaniaNueva).subscribe(
      resultado => this.ciudadesEditar = resultado
    );
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.idSedeNueva = -1;
    this.sedesEditar = null;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaNueva, this.idCiudadNueva).subscribe(
      resultado => this.sedesEditar = resultado
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarSedes(): void {
    this.sedeService.listarSedes().subscribe(
      resultado => this.sedes = resultado
    );
  }

  public listarAmbientes(): void {
    this.listaItemService.listaItemsPorCodigoLista(this.codigoListaAmbientes).subscribe(
      resultado => this.ambientes = resultado
    );
  }

  public buscarVlans(cargandoModal): void {
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    this.vlanService.consultarVlans(this.idCompaniaSeleccionada, this.idCiudadSeleccionada,
      this.idSedeSeleccionada, this.idAmbienteSelecccionado).subscribe(
        resultado => {
          this.vlans = resultado;
          this.modalRef.close();
        }
      );
  }

  public async exportarVlans(cargandoModal): Promise<void> {
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    const blob = await this.vlanService.exportarVlans(this.vlans);
    const url = window.URL.createObjectURL(blob);

    const link = this.downloadLink.nativeElement;
    link.href = url;
    link.download = 'Vlans.xls';
    link.click();
    window.URL.revokeObjectURL(url);
    this.modalRef.close();
  }

  public inactivarVlan(cargandoModal) {
    this.modalRef.close();
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    this.vlanService.InactivarVlan(this.vlans[this.indexSeleccionado]).subscribe(
      resultado => {
        this.vlans[this.indexSeleccionado] = resultado;
        this.modalRef.close();
      }
    );
  }

  public confirmacionInactivarVlan(vlanDto: ConsultaVlansDto, confirmarModal) {
    this.indexSeleccionado = this.vlans.indexOf(vlanDto);
    this.modalRef = this.modalService.open(confirmarModal, { size: 'lg' });
  }

  public consultarPermisoInactivar(): void {
    this.sesionService.permisoInactivarVLAN().subscribe(
      resultado => this.puedeInactivarVLAN = resultado
    );
  }

  public abrirEditarVlan(editarVlanModal, vlanSeleccionado: ConsultaVlansDto): void {
    this.indexSeleccionado = this.vlans.indexOf(vlanSeleccionado);
    this.sedesEditar = this.sedes;
    this.ciudadesEditar = this.ciudades;
    this.idCompaniaNueva = this.vlans[this.indexSeleccionado].idCompania;
    this.idCiudadNueva = this.vlans[this.indexSeleccionado].idCiudad;
    this.idSedeNueva = this.vlans[this.indexSeleccionado].idSede;
    this.estadoNuevo = this.vlans[this.indexSeleccionado].indicadorHabilitado;
    this.nombreNuevo = this.vlans[this.indexSeleccionado].nombreVlan;
    this.modalRef = this.modalService.open(editarVlanModal, { size: 'lg' });
  }

  public enviarEditar(cargandoModal, resultadoModal) {
    let vlan: ConsultaVlansDto = this.vlans[this.indexSeleccionado];
    vlan.idCompania = this.idCompaniaNueva;
    vlan.idCiudad = this.idCiudadNueva;
    vlan.idSede = this.idSedeNueva;
    vlan.indicadorHabilitado = this.estadoNuevo;
    vlan.nombreVlan = this.nombreNuevo;
    this.modalRef.close();
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    this.administradorIpService.editarVlan(vlan).subscribe(
      resultado => {
        vlan = resultado;
        this.modalRef.close();
        if (vlan != null) {
          this.modalRef = this.modalService.open(resultadoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
        }
      }
    );
  }

  public cerrarResultadoModal(cargandoModal) {
    this.modalRef.close();
    this.buscarVlans(cargandoModal);
  }
  public liberarVlan(observacion: string) {

    let vlan: ConsultaVlansDto = this.vlans[this.indexSeleccionado];
    if (observacion.includes('GENERAR')) {
      vlan.observaciones = observacion;
    }
    this.administradorIpService.liberarVlan(vlan).subscribe(
      resultado => {
        vlan = resultado;
        this.modalRef.close();
        if (vlan != null) {
          swal("Se proceso correctamente la vlan", "", "success").then(function () {
            // Redirect the user
            window.location.href = "/#/solicitar-ip";
          });
        }
      }
    );

  }
  public confirmarLiberacion(): void {

    swal({
      title: "¿Estas seguro que deseas liberar esta vlan y dejar en blanco todas las ips asociadas a esta ?",
      icon: "warning",
      buttons: ["No", "Si"],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            title: "Procesando",
            text: "espere un momento",
            icon: "warning",
            dangerMode: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
            buttons: {
            }
          } as any)
          this.liberarVlan('')
        }
      });
  }

  public confirmarCreacionIps(): void {

    swal({
      title: "¿Estas seguro que deseas crear las ips? esto solamente funcionara si la vlan no tiene ninguna direccion ip creada",
      icon: "warning",
      buttons: ["No", "Si"],
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal({
            title: "Procesando",
            text: "espere un momento",
            icon: "warning",
            dangerMode: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
            buttons: {
            }
          } as any)
          this.liberarVlan('GENERAR')
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/consultar-vlan/consultar-vlan.component.ts